import { ActionButton } from '../ActionButton/ActionButton';

export const CommandButton = ActionButton;
